// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"520":"ef854588487d8696","523":"2f31284c7b5d624d","552":"6da9ce065f8e6f60"}[chunkId] + ".js";
};